import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useWizard } from "../../context/WizardContext";
import { CurrencyInput } from "../shared/CurrencyInput";
import { cn } from "@/lib/utils";

export function BusinessStep2Income() {
  const { businessData, updateBusinessData } = useWizard();
  const inc = businessData.income ?? {};
  const gross = inc.grossReceipts ?? 0;
  const returns = inc.returnsAndAllowances ?? 0;
  const net = gross - returns;

  const set = (patch: Partial<typeof inc>) => {
    updateBusinessData({ income: { ...inc, ...patch } });
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-foreground">Income</h2>
        <p className="text-sm text-muted-foreground">
          Enter gross receipts and returns. Net income is calculated for you.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Income</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <CurrencyInput
            label="Gross Receipts or Sales"
            value={inc.grossReceipts}
            onChange={(v) => set({ grossReceipts: v })}
          />
          <CurrencyInput
            label="Returns and Allowances"
            value={inc.returnsAndAllowances}
            onChange={(v) => set({ returnsAndAllowances: v })}
          />
          <div className="rounded-md border border-border bg-muted/50 px-4 py-3">
            <p className="text-sm font-medium text-foreground">
              Net Income: {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(net)}
            </p>
            <p className="text-xs text-muted-foreground">Gross Receipts − Returns and Allowances</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
